import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Category } from '../models/category.model';
import {
  Company,
  QuestionDetail,
  QuestionFormModel,
} from '../models/question-detail.model';
import { Question } from '../models/question.model';
import {
  ParentQuestion,
  SearchQuestionsParams,
} from '../models/parent-question.model';

export const QuestionActions = createActionGroup({
  source: 'Questions',
  events: {
    'Load Questions': emptyProps(),
    'Load Questions Success': props<{ questions: Question[] }>(),
    'Load Questions Failure': props<{ error: string }>(),
    'Set Search': props<{ search: string }>(),
    'Reset State': emptyProps(),

    'Select Question': props<{ id: number }>(),
    'Deselect Question': emptyProps(),

    'Load Detail Success': props<{ detail: QuestionDetail }>(),
    'Load Detail Failure': props<{ error: string }>(),

    'Create Question': props<{ model: QuestionFormModel }>(),
    'Create Question Success': emptyProps(),
    'Create Question Failure': props<{ error: string }>(),

    'Update Question': props<{ id: number; model: QuestionFormModel }>(),
    'Update Question Success': props<{
      id: number;
      model: QuestionFormModel;
    }>(),
    'Update Question Failure': props<{ error: string }>(),

    'Delete Question': props<{ id: number }>(),
    'Delete Question Success': emptyProps(),
    'Delete Question Failure': props<{ error: string }>(),

    'Delete Localization': props<{ questionId: number; locale: string }>(),
    'Delete Localization Success': props<{ locale: string }>(),
    'Delete Localization Failure': props<{ error: string }>(),

    'Load Companies': emptyProps(),
    'Load Companies Success': props<{ companies: Company[] }>(),
    'Load Companies Failure': props<{ error: string }>(),

    'Load Categories': emptyProps(),
    'Load Categories Success': props<{ categories: Category[] }>(),
    'Load Categories Failure': props<{ error: string }>(),

    'Search Parent Questions': props<{ params: SearchQuestionsParams }>(),
    'Search Parent Questions Success': props<{ results: ParentQuestion[] }>(),

    'Search Child Questions': props<{ params: SearchQuestionsParams }>(),
    'Search Child Questions Success': props<{ results: ParentQuestion[] }>(),
  },
});
